import API from '../lib/api'

export const addCustomerTypeApi = async data => {
  try {
    const response = await API.post(`/restaurant/customer-types`, data)
    return response.data
  } catch (error) {
    console.error('Error adding customer type:', error)
    return {
      status: 'failure',
      message: error.response?.data.message || 'Error adding customer type.'
    }
  }
}

export const getAllCustomerTypeApi = async (restaurantId, per_page, status) => {
  try {
    const { data } = await API.get(
      `/restaurant/${restaurantId}/customer-types?per_page=${per_page}${
        status ? `&status=${status}` : ''
      }`
    )

    return data
  } catch (error) {
    return (
      error.response?.data || {
        status: 'failure',
        message: 'Something went wrong.'
      }
    )
  }
}

export const updateCustomerTypeApi = async (id, data) => {
  try {
    const response = await API.put(`/restaurant/customer-types/${id}`, data)
    return response.data
  } catch (error) {
    console.error('Error updating customer type:', error)
    return {
      status: 'failure',
      message: error.response?.data.message || 'Error updating customer type.'
    }
  }
}

export const deleteCustomerTypeApi = async id => {
  try {
    const response = await API.delete(`/restaurant/customer-types/${id}`)

    return response.data
  } catch (error) {
    return error.response.data
  }
}

export const addDiscountApi = async data => {
  try {
    const response = await API.post(`/restaurant/discounts`, data)
    return response.data
  } catch (error) {
    console.error('Error adding discount:', error)
    return {
      status: 'failure',
      message: error.response?.data.message || 'Error adding discount.'
    }
  }
}

export const updateDiscountApi = async (id, data) => {
  try {
    const response = await API.put(`/restaurant/discounts/${id}`, data)
    return response.data
  } catch (error) {
    console.error('Error updating customer type:', error)
    return {
      status: 'failure',
      message: error.response?.data.message || 'Error updating discount.'
    }
  }
}

export const getAllDiscountApi = async (
  restaurantId,
  per_page,
  page,
  search_term,
  customer_type_id,
  status,
  extraParams = {}
) => {
  try {
    let params = {};
    if (typeof per_page === 'object' && per_page !== null) {
      params = { ...per_page };
    } else {
      if (per_page !== undefined && per_page !== null && per_page !== '' && per_page !== 0 && per_page !== '0') {
        params.per_page = per_page;
      }
      if (page !== undefined && page !== null && page !== '') {
        params.page = page;
      }
      if (search_term) {
        params.search_term = search_term;
      }
      if (customer_type_id && customer_type_id !== "0") {
        params.customer_type_id = customer_type_id;
      }
      if (status && status !== "0") {
        params.status = status;
      }
      if (typeof extraParams === 'object' && extraParams !== null) {
        params = { ...params, ...extraParams };
      }
    }

    const queryEntries = Object.entries(params).filter(
      ([_, v]) => v !== undefined && v !== null && v !== ''
    );
    const queryString = new URLSearchParams(queryEntries).toString();

    const { data } = await API.get(
      `/restaurant/${restaurantId}/discounts${queryString ? `?${queryString}` : ''}`
    );

    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: 'failure',
        message: 'Something went wrong.'
      }
    );
  }
};
export const toggleDiscountApi = async id => {
  try {
    const { data } = await API.put(`restaurant/discounts/${id}/toggle-status`)

    return data
  } catch (error) {
    return (
      error.response?.data || {
        status: 'failure',
        message: 'Something went wrong.'
      }
    )
  }
}

export const deleteDiscountTypeApi = async id => {
  try {
    const response = await API.delete(`restaurant/discounts/${id}`)

    return response.data
  } catch (error) {
    return error.response.data
  }
}
